export enum OcrFlowTypes {
  CREDIT_PROPOSAL = 'CREDIT_PROPOSAL',
  TRV_CEX = 'TRV_CEX',
  CUSTOMER = 'CUSTOMER',
  ORIGINATION_WITHOUT_PROPOSAL = 'ORIGINATION_WITHOUT_PROPOSAL',
}
export enum OcrType {
  INVOICE = 'INVOICE',
}

export enum OcrAvailabilityConfigurationTypes {
  NO_RESTRICTIONS = 'NO_RESTRICTIONS',
  RELIABLE = 'RELIABLE',
  NO_MANUAL = 'NO_MANUAL',
  RELIABLE_NO_MANUAL = 'RELIABLE_NO_MANUAL',
  NFC = 'NFC',
  ANALYZE = 'ANALYZE',
}

export enum OcrStatus {
  PEN = 'PEN',
  NVL = 'NVL',
  VLD = 'VLD',
  NRC = 'NRC',
  EXP = 'EXP',
  IBD = 'IBD',
  NFC = 'NFC',
  NBC = 'NBC',
  NBW = 'NBW',
  IRS = 'IRS',
  DTI = 'DTI',
}

export enum OcrCompliance {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  BASIC = 'BASIC',
}

export interface OcrAPIRequest {
  flow: OcrFlowTypes;
  availability_configuration: OcrAvailabilityConfigurationTypes;
}

export interface OcrNfcRequest {
  type: string;
  client_certificate_status: string | null;
  root_certificate_status: string | null;
  name: string;
  last_name: string;
  birth_date: string;
  expiration_date: string;
  document_id: string;
  nationality: string;
  gender: string;
  support_number: string;
  face_photo: string;
  card_access_number: string;
  address?: string;
  birth_place: string;
  birth_country?: string;
  fathers_name?: string;
  mothers_name?: string;
  signature_photo: string;
  ocr_id?: string;
}

export interface OcrAPIData {
  ocr_document_id: string;
  type: string;
  flow: OcrFlowTypes;
  token: string;
  third_party: string;
  process_type: string;
  url_access: string;
  status: OcrStatus;
  accessed: boolean;
  document_id: string;
  availability_configuration: string;
  compliance: OcrCompliance;
  communication_data: {
    phone: string;
    email: string;
    customer_name: string;
    merchant_name: string;
  };
  tags: {
    key: string;
    value: string;
  }[];
}
export interface OcrResponse {
  result: {
    status: boolean;
    http_code: number;
    info: string;
  };
  data: OcrAPIData | OcrNfcApiData;
}

export interface OcrNfcApiData {
  status: OcrStatus;
  global_attempts_remaining: number;
  nfc_attempts_remaining: number;
  third_party_response: OcrNfcThirdParty;
}

export interface OcrNfcThirdParty {
  nationality: string;
  gender: string;
  birth_place: string;
  support_number: string;
  birth_country: string;
}
export interface OcrPostInvoice {
  flow: OcrFlowTypes;
  availability_configuration: OcrAvailabilityConfigurationTypes;
  type: OcrType;
}

export interface PostInvoice {
  document: string;
}